import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CircularIndicator from '../common/indicators/circularIndicator';

const TableTitle = props => (
  <div className="filter-select-wraper">
    <div>
      <span>{props.language.detail_waiting_times.detailTruck.ranking}:</span>
      <span className="filter-item">
        {props.rankingLabel === 'vehicle' ? 'Equipo' : 'Conductores'}
      </span>
    </div>
    <div className="test">
      <i className="fas fa-sort-down arrow-down " />
      <div className="dropdown-content">
        <a href="#" data-type="vehicle" onClick={props.handleRanking}>
          {props.language.detail_waiting_times.detailTruck.team}
        </a>
        <a href="#" data-type="person" onClick={props.handleRanking}>
          {props.language.detail_waiting_times.detailTruck.driver}
        </a>
      </div>
    </div>
  </div>
);

export default TableTitle;



// WEBPACK FOOTER //
// ./source/client/components/detail_truck/tableTitle.jsx